const Form078TC = {
    stepName: {
        information: "基本資料",
        partA: "甲部\n原任合約教職員及代職人員資料",
        partB: "乙部\n申領金額及\n補充資料",
        partC: "丙部\n認證",
        confirm: "確認",
    },
    notes: {
        notesTitle: "聲明",
        importantNote1:
            "[i.e. 請提交電子表格或紙質表格，請注意，如果提交了重複的申請，處理過程可能會受影響。",
        importantNote2:
            "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向有關高級學校發展主任提出。]",
        importantNote3:
            "此表格只適用於聘用代職人員替代以教育局現金津貼聘請的合約教職員放取14個星期有薪產假。",
        note1: "如原任合約教職員<u>未符合</u>《僱傭條例》（第57章）的規定放取<u>有薪</u>產假，即使學校有聘任代職人員替代其職務，亦<u>不可</u>向教育局申領「額外代職人員津貼」。",
        note2: "額外薪金指聘任代職人員以替代休假合約教職員放取<u>額外四個星期法定有薪產假</u>的代職人員薪金開支（即最多28日）。",
        note3: "發還金額的<u>上限</u>以原任合約教職員於正常工作日的薪酬釐定（即並非其產假薪酬）。如原任合約教職員為兼任人員，則須填寫<u>已反映</u>其兼任職務的月薪。如原任合約教職員額外四個星期產假橫跨兩個曆月，而兩個曆月的月薪並不相同，則須分別列出該兩個曆月的月薪資料。",
        note3a: "發還金額的<u>上限</u>以原任合約教職員於正常工作日的薪酬釐定（即並非其產假薪酬）。如原任合約教職員為兼任人員，則須填寫<u>已反映</u>其兼任職務的月薪。如原任合約教職員額外四個星期產假橫跨兩個曆月，而兩個曆月的月薪並不相同，則須分別列出該兩個曆月的月薪資料。此外，學校亦須填寫原任合約教職員於額外四個星期產假期間的<u>每日平均工資</u>（以原任合約教職員的月薪金額×12個月/365日計算）。",
        note4: "原任合約教職員的薪金來源必須為<u>教育局提供的現金津貼</u>。",
        note5: "如原任合約教職員在放取額外四星期有薪產假期間，學校曾聘任一名或以上的代職人員，學校須<u>分別</u>列出各代職人員的姓名及聘用詳情。",
        note6: "聘請代職人員的全職工作比例<u>不可超逾</u>原任合約教職員於放取額外四星期（即28日）有薪產假期間，屬教育局現金津貼支薪的全職工作比例[即表格({{field}})欄內填報的全職工作比例]。",
        note7: "代職人員的月薪金額<u>不得高於</u>原任合約教職員的月薪金額[即表格(b)欄內填報的「月薪」金額]。如原任合約教職員額外四個星期產假橫跨兩個曆月，而該兩個曆月的月薪金額並不相同，相關代職人員的月薪金額亦<u>不可高於</u>原任合約教職員在該兩個曆月的<u>相應</u>薪酬。如代職人員為兼任人員，則須填寫<u>已反映</u>其兼任職務的月薪，並於表格(c)欄填寫其全職工作比例。",
        note7a: "代職人員的日薪率<u>不得高於</u>原任合約教職員的每日平均工資[即表格(h)欄內填報的「經換算的每日平均工資」金額]。如原任合約教職員額外四個星期產假橫跨兩個曆月，而該兩個曆月的月薪及經換算的每日平均工資並不相同，代職人員的日薪率亦<u>不可高於</u>原任合約教職員在該兩個曆月的<u>相應</u>每日平均工資。如代職人員為兼任人員，則須填寫<u>已反映</u>其兼任職務的日薪，並於表格(i)欄填寫其全職工作比例。",
        note8: "代職曆日日數指由起始日至完結日期間的曆日數目（首尾兩天包括在內），此欄的代職曆日總日數<u>不可超逾28日</u>。如該代職人員在受僱期間曾放取無薪假期，<u>代職曆日日數須扣除無薪假期的日數</u>，學校亦須於乙部(i)提供詳細資料。",
        note8a: "實際工作日數<u>不應</u>包括公眾假期、由學校自行訂定的假期或教職員無需執行職務的任何日期。實際工作總日數亦<u>不可超逾28日</u>。",
        note9: "薪金應根據代職曆日日數按比例計算[以代職人員的每日平均工資（代職人員的月薪金額×12個月/365日）×代職曆日日數]。",
        note9a: "薪金應根據代職人員的日薪率×代職人員的實際工作日數計算。",
        note10: `強積金計劃供款津貼的計算方法為有關入息的5% 供款，並受限於<u>按28日比例計算</u>的最高有關入息水平的供款（1,381元 = 現時最高供款每月1,500元×12個月/365日×28日）。如學校無需向該代職人員的強積金計劃供款，請在此欄填寫"0"。`,
        termsTips1: "申請人應仔細閱讀並同意",
        termsTips2: "隱私數據的註意事項",
        agreeTips: "我已閱讀、理解並同意上述條款和條件。",
    },
    button: {
        addSupplyStaff: "新增代職人員",
        removeSupplyStaff: "移除代職人員",
    },
    serial: {
        tips: {
            num1: "(ⅰ)",
            num2: "(ⅱ)",
            num3: "(ⅲ)",
            num4: "(ⅳ)",
            num5: "(ⅴ)",
            num6: "(ⅵ)",
            num7: "(ⅶ)",
            num8: "(ⅷ)",
        },
    },
    label: {
        basicOption: {
            note: "註",
            contactPerson: "學校聯絡人",
        },
        informationTitle: "學校資料",
        schoolName: "學校名稱",
        schoolCode: "學校代碼",
        month: "月份",
        year: "年份",
        ssdo: "高級學校發展主任",
        contactPerson: "學校聯絡人（以便教育局處理本表格時作查詢之用）",
        telNo: "電話號碼",
        pleaseSpecify: "請註明",
        partAOption: {
            tips1: "本校欲申領上述津貼以發還因原任合約教職員放取延長有薪產假至14個星期",
            tips2: "，而聘任合資格代職人員所支付的額外薪金",
            tips3: "， 詳情如下：",
            title: "<b>甲部 原任合約教職員及代職人員資料</b>",
            titleTips:
                "（請使用下列表格I及II分別填寫以月薪及日薪形式聘請的代職人員資料）",
            title1: "I. 以月薪形式聘請的代職人員",
            monthTips: "放取14個星期有薪產假的<b>原任合約教職員</b>資料",
            name: "姓名",
            teachingStaffLabel: "是否为教學人員",
            teachingStaff: {
                Yes: "教學人員",
                No: "非教學人員",
            },
            leavePeriod: "休假日期",
            firstTenWeekLabel: "首10個星期",
            additionalWeekLabel: "額外四個星期 ({{serial}})",
            additionalWeek: "額外四個星期產假的薪金資料",
            additionalWeekTips:
                "[只計算由教育局現金津貼所支付的薪金] ({{serial}})",
            monthlySalary: "月薪",
            amountUnit: "（元）",
            month: "月",
            rank: "職級",
            percentage: "佔全職工作比例",
            fundingSource: "薪金來源",
            fundingSourceFile:
                "原任合約教職員放取14個星期有薪產假期間的薪金證明",
            monthlyPaidTips:
                "在原任合約教職員放取額外四個星期有薪產假 [即表格(a)欄]期間所有以<b>月薪聘請的代職人員</b>資料",
            dailyRatedTips:
                "在原任合約教職員放取額外四個星期有薪產假 [即表格(g)欄]期間所有以<b>日薪聘請的代職人員</b>資料",
            supplyStaffName: "代職人員姓名",
            substitutionPeriodTitle:
                "代職日期 <i>[不得超逾表格({{serial}})欄所示日期]</i>",
            substitutionPeriod: "代職日期",
            from: "由",
            to: "至",
            workingDays: "代職曆日日數",
            salaryAmount: "薪金",
            salaryAmountFile:
                "所有代職人員（包括首10個星期及額外四個星期）的薪酬收據",
            mpfSubsidy: "強積金計劃供款津貼",
            mpfSubsidyFile: "所有代職人員的強積金計劃供款的證明資料（如適用）",
            mpfSubsidyFileTips:
                "[如代職期少於60個曆日，但代職人員須向強積金計劃供款，請提供理由及相關證明]",
            grantAmount: "津貼金額 (f) = (d) + (e)",
            grantAmountDaily: "津貼金額 (l) = (j) + (k)",
            grantAmountMsg: "津貼金額",
            dayAmount: "[ 經換算的每日平均工資為",
            dayAmountR: "]",
            dailyRate: "日薪率",
            actualWorkingDays: "實際工作日數",
            totalDays: "總日數",
            totalAmount: "總額",
            title2: "II. 以日薪形式聘請的代職人員",
        },
        partBOption: {
            title: "<b>乙部 申領金額及補充資料</b>",
            stepNote1: "於原任合約教職員放取14個星期有薪產假期間，",
            stepNoteChild: {
                note1: "已連續14個星期聘任代職人員，以履行原任合約教職員的職務。",
                note2: "曾聘任代職人員，以履行原任合約教職員的職務，但<u>代職時段少於14個星期</u>，原因是（可選多於一項）：",
            },
            childNoteOption: {
                childNoteA1: "教職員放取之有薪產假有部分時段與主要學校假期（",
                childNoteA2: "學校在某時段未能聘請合適的代職人員",
                childNoteA3: "學校未有足夠時間招聘代職人員",
                childNoteA4:
                    "學校需要在該段產假期間聘請多於一名代職人員，而他們的任職期未能完全連接",
                childNoteA5: "月薪代職人員曾於受僱期間放取無薪假期，詳情為：",
                childNoteA6: "其他原因",
            },
            childNoteEndA1: "）重疊，故此，學校無需在該段產假期間聘請代職人員",
            stepNote2Start:
                "現以<u>實報實銷形式</u>向教育局申領「額外代職人員津貼」共",
            stepNote2End:
                "元[原則上為表格(f)及(l)欄的總額]，以發還因原任合約教職員放取額外四個星期法定有薪產假的代職人員薪金開支（即最多28日）。謹此附上<u>經校監簽署核證</u>的下列文件副本，以供查考：",
            childNoteBOption: {
                childNoteB1: "原任合約教職員的薪金證明；",
                childNoteB2:
                    "所有代職人員（包括首10個星期及額外四個星期）的薪酬收據；及",
                childNoteB3:
                    "所有代職人員的強積金計劃供款的證明資料（如適用）[如代職期少於60個曆日，但代職人員須向強積金計劃供款，請提供理由及相關證明]。",
            },
            left: "（",
            right: "）",
            detailMsg: "詳情",
            specifyMsg: "原因",
            leaveType: {
                ch: "聖誕節假期",
                cnyh: "農曆新年假期",
                eh: "復活節假期",
                sv: "暑假",
            },
        },
        partCOption: {
            title: "丙部 認證",
            noteTitle: "本人證實—",
            surplusTeachers: "過剩教師",
            teacherNumber: "過剩教師人數",
            claimDate: "申請日期",
            certifyNote1:
                "已審閱相關證明文件（包括註冊醫生、註冊助產士或註冊中醫簽發證實懷孕的有效證明書、註明預產期或實際分娩日期（按適當情況而定）的醫生證明書等），並按照《僱傭條例》（第57章）及教育局相關規定批准上述以現金津貼聘請的合約教職員放取延長有薪產假至14個星期；",
            certifyNote2:
                "已要求代職人員進行性罪行定罪紀錄查核，並已致電自動電話查詢系統收聽代職人員性罪行定罪紀錄查核的結果；",
            certifyNote3:
                "所聘用的代職人員如屬教師，他／她必須是檢定教師，或已具備可申請成為檢定教員或准用教員的所需資歷，並在上任前提交教師註冊申請。學校亦已仔細查閱教師的身份證明文件和教師註冊證的正本及／或查詢其教師註冊身份和相關資料；所聘用的代職人員如屬非教學的專責人員，他／她亦須具備相關的資格；",
            certifyNote4: "本校",
            certifyNoteNo: "並",
            certifyNoteMiddle: "過剩常額教師",
            certifyNoteYes: "名",
            certifyNote4Start:
                "，而在聘請代課教師替代原任合約教師放取額外四個星期法定有薪產假期間，過剩常額教師數目<u>已經抵銷</u> [即在同一時間內，休假連續三日或以上的教師數目（包括常額教師及以教育局「現金津貼」聘請的合約教師的數目）超逾過剩常額教師數目。如有需要，請註明有關詳情：",
            certifyNote4Char: "]。",
            certifyNote4End:
                "如學校的過剩常額教師數目未被抵銷，因額外四個星期有薪假期而衍生的代職人員薪金開支將不會獲得發還；",
            certifyNote5:
                "上述各部分提供的資料正確無誤及完整（已包括原任合約教職員放取額外四個星期產假期間的<span style='border-bottom: 3px double #000;'>所有</span>代職人員的聘用資料），本校就此個案的申請已完成，亦明白如上述資料及相關證明文件不齊全，教育局不會處理本表格；",
            certifyNote6:
                "學校已先行向代職人員支付薪酬及其他法定責任的相關開支；",
            certifyNote7:
                "如發放的津貼額多於本校應得，本校會把多收的津貼退還政府；及",
            certifyNote8:
                "已支付予該原任合約教職員的額外四個星期法定產假薪酬及額外代職人員津貼不曾／將不會獲其他政府撥款支付／補貼。",
            applicationDate: "申請日期",
            supervisorName: "校監姓名",
        },
        slash: "／",
        smcImc: "校董會／法團校董會",
    },
    select: {
        monthOption: [
            { key: "", value: "請選擇" },
            { key: "01", value: "01" },
            { key: "02", value: "02" },
            { key: "03", value: "03" },
            { key: "04", value: "04" },
            { key: "05", value: "05" },
            { key: "06", value: "06" },
            { key: "07", value: "07" },
            { key: "08", value: "08" },
            { key: "09", value: "09" },
            { key: "10", value: "10" },
            { key: "11", value: "11" },
            { key: "12", value: "12" },
        ],
        ssdoOption: {
            CWD: "中西區",
            SD: "南區",
            WCD: "灣仔區",
            ID: "離島區",
            HKED: "東區",
            KCD: "九龍城區",
            SSPD: "深水埗區",
            SKD: "西貢區",
            KTD: "觀塘區",
            WTSD: "黃大仙區",
            YTMKD: "油尖旺區",
            TPD: "大埔區",
            ND: "北區",
            STD: "沙田區",
            KCTYD: "葵青區",
            TWD: "荃灣區",
            TMD: "屯門區",
            YLD: "元朗區",
        },
        supplyStaffOption: {
            PartAI: "I. 以月薪形式聘請的代職人員",
            PartAII: "II. 以日薪形式聘請的代職人員",
        },
        schoolIncorporatedOption: {
            smc: "校董會",
            imc: "法團校董會",
        },
        surplusTeachersOption: {
            Yes: "有",
            No: "沒有",
        },
    },
    errorMsg: {
        required: "此項必須填寫",
        twoRequired: "前兩項必須填寫",
        maxOneDecimal: "此項必須為小數後最多1位",
        numberUnit: "該字段必須最小單位為0.5",
        validPrice: "請輸入一個有效的價格",
        numberMax: "此項必須為最多{{number}}位",
        telMax: "電話號碼必須為最多12位數",
        monthDiffError: "請選擇不同的月份",
        monthRangeError: "請選擇休假日期「額外四個星期」範圍內的月份",
        substitutionPeriodError: "此項必須在({{fild}})欄所示日期範圍之內",
        monthlySalaryError: "此項不得高於(b)欄內填報的月薪金額",
        percentageError: "此項不得高於({{fild}})欄內填報的佔全職工作比例",
        dailyRateError: "此項不得高於(h)欄「經換算的每日平均工資」金額",
    },
};
export default Form078TC;
